import { PRIVATE_HTTP as http } from '../http-common';

const GetPreference = async (body: object) => {
  return http().post(`/api/v4/preferences`, body);
};

const banks = async () => {
  return http().get(`/api/v4/banks`);
};

const creditCards = async () => {
  return http().get(`/api/v4/credit_cards`);
};

const paymentMethods = async (policyId: number) => {
  return http().get(`/api/v4/policies/${policyId}/payment_methods`);
};

const confirmPaymentMethods = async (policyId: number, body: any) => {
  return http().post(
    `/api/v4/policies/${policyId}/endorsements/payment_method_change`,
    body
  );
};

const validateCbuNumber = async (cbu: number) => {
  return http().get(`/api/v4/banks/validate_cbu?number=${cbu}`);
};

const validateCreditCardNumber = async (creditCardNumber: number) => {
  return http().get(`/api/v4/credit_cards/validate?number=${creditCardNumber}`);
};

export {
  GetPreference,
  banks,
  creditCards,
  paymentMethods,
  confirmPaymentMethods,
  validateCbuNumber,
  validateCreditCardNumber,
};
